import type { SpreadTemplate } from "../types";
import { BASE_SPREAD_TEMPLATES } from "./base";

// English comment: A5 landscape spread templates (start from base; adjust manually later)
export const SPREADS_A5_LANDSCAPE: SpreadTemplate[] = BASE_SPREAD_TEMPLATES.map((b) => ({
  id: `a5l_${b.idSuffix}`,
  name: b.name,
  format_group: "a5_landscape",
  unitKind: "spread",
  blocks: b.blocks
}));
